export default "__VITE_ASSET__BS_XzfY5__"